<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="ipadfp"><img alt="Cover Page Image" class="imagefp" src="image/9781481405676.jpg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?13e1cb64